<template>
  <div>
    <v-container grid-list-md>
      <div class="hidden-sm-and-down">
        <v-card class = "pa-1">
        <cal :data="list" @edit="editEvent" @create="addEvent" @remove="onRemove" />
        </v-card>
      </div>
      <h3 class="headline mb-0 mt-3" v-if="list.length>0">All Events</h3>

      <v-layout row wrap>
        <v-flex v-for="item in list" v-bind:key="item._id" xs12 sm6 md4 lg3 xl2>
          <v-hover>
            <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`">
              <v-card-title primary-title>
                <div>
                  <h3 class="headline mb-0">{{item.name}}</h3>
                  <small>{{new Date(item.time).toLocaleString()}}</small>
                </div>
              </v-card-title>

              <v-card-actions>
                <v-layout align-center justify-space-between row>
                  <v-btn text color="red lighten-1" @click="onRemove(item)">Remove</v-btn>
                  <v-btn text color="blue" @click="editEvent(item)">Edit</v-btn>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-hover>
        </v-flex>
      </v-layout>
    </v-container>

    <v-btn fab bottom right color="light-blue darken-1" dark fixed @click="addEvent">
      <v-icon>add</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" persistent width="800px">
      <!-- <v-card>
        <v-card-title class="grey lighten-4 py-4 title">Create event</v-card-title>
      <v-container grid-list-sm class="pa-4">-->
      <v-stepper v-model="e1">
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1" step="1" @click="e1=1;">Event details</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="e1 > 2" step="2" @click="e1=2;">Event date</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="3" @click="e1=3;">Event time</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card class="mb-2" flat>
              <v-container grid-list-sm class="pa-4">
                <v-layout row wrap>
                  <v-flex xs12 align-center justify-space-between>
                    <v-layout align-center>
                      <v-text-field prepend-icon="business" placeholder="Name" v-model="event.name"></v-text-field>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      prepend-icon="message"
                      placeholder="Message to send out to everyone in this channel."
                      v-model="event.message"
                    ></v-textarea>
                    <small>{{String(event.message).length}} / 1200</small>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
            <v-container>
              <v-layout>
              <v-btn color="primary" @click="e1 = 2">Continue</v-btn>

              <v-btn text @click="dialog = false;e1=1;">Cancel</v-btn>
              <v-spacer />
              <v-btn color="primary" @click="onSave" v-if="event._id!=null">Save Now</v-btn>
              </v-layout>
            </v-container>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-card class="mb-2" flat>
              <h3 class="headline mb-0">Event Date</h3>
              <v-container grid-list-sm class="pa-4">
                <v-layout row wrap>
                  <v-flex xs12 align-center justify-space-between>
                    <v-layout align-center justify-center row fill-height>
                      <v-date-picker
                        v-model="picker"
                        full-width
                        no-title
                        scrollable
                        reactive
                        :min="new Date().toISOString()"
                      ></v-date-picker>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
                        <v-container>
              <v-layout>
              <v-btn color="primary" @click="e1 = 3">Continue</v-btn>

              <v-btn text @click="dialog = false;e1=1;">Cancel</v-btn>
              <v-spacer />
              <v-btn color="primary" @click="onSave" v-if="event._id!=null">Save Now</v-btn>
              </v-layout>
            </v-container>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-card class="mb-2" style="min-height:200px;" flat>
              <h3 class="headline mb-0">Event Time</h3>
              <v-container grid-list-sm class="pa-4">
                <v-layout row wrap>
                  <v-flex xs12 align-center justify-space-between>
                    <v-layout align-center justify-center row fill-height>
                      <v-container fluid grid-list-xl>
                        <v-layout wrap align-center>
                          <v-flex xs12 sm6 d-flex>
                            <v-select :items="hours" label="Hour" solo v-model="event.hour"></v-select>
                          </v-flex>
                          <v-flex xs12 sm6 d-flex>
                            <v-select :items="minutes" label="Minute" solo v-model="event.minute"></v-select>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>

            <v-btn
              color="primary"
              @click="onSave"
            >{{(event._id!=null)?"Update Event":"Create Event"}}</v-btn>

            <v-btn text @click="e1=1;dialog = false;">Cancel</v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-dialog>
    <v-loading :dialog="isLoading" />
  </div>
</template>
<script>
import cal from "@/components/events/calendar";
import groupService from "@/services/groups/group";
import eventService from "@/services/groups/events";
export default {
  components: { cal: cal },
  props: ["id"],
  data: () => ({
    isLoading: false,
    dialog: false,
    picker: new Date().toISOString().substr(0, 10),
    time: new Date().toISOString(),
    // time: null,
    e1: 0,
    list: [],
    hours: [
      // { text: "5 AM", value: 5 },
      { text: " 12 Midnight", value: 0 },
      { text: " 1 AM", value: 1 },
      { text: " 2 AM", value: 2 },
      { text: " 3 AM", value: 3 },
      { text: " 4 AM", value: 4 },
      { text: " 5 AM", value: 5 },
      { text: " 6 AM", value: 6 },
      { text: " 7 AM", value: 7 },
      { text: " 8 AM", value: 8 },
      { text: " 9 AM", value: 9 },
      { text: "10 AM", value: 10 },
      { text: "11 AM", value: 11 },
      { text: "12 Noon", value: 12 },
      { text: " 1 PM", value: 13 },
      { text: " 2 PM", value: 14 },
      { text: " 3 PM", value: 15 },
      { text: " 4 PM", value: 16 },
      { text: " 5 PM", value: 17 },
      { text: " 6 PM", value: 18 },
      { text: " 7 PM", value: 19 },
      { text: " 8 PM", value: 20 },
      { text: " 9 PM", value: 21 },
      { text: "10 PM", value: 22 },
      { text: "11 PM", value: 23 }
    ],
    minutes: [
      { text: "00", value: 0 },
      { text: "15", value: 15 },
      { text: "30", value: 30 },
      { text: "45", value: 45 }
    ],
    event: {
      _id: null,
      name: "",
      message: "",
      hour: 7,
      minute: 30
    },
    default_event: {
      _id: null,
      name: "",
      message: "",
      hour: 7,
      minute: 30
    }
  }),
  methods: {
    initialize() {
      this.isLoading = true;
      eventService
        .getEvents(this.id)
        .then(data => {
          this.isLoading = false;
          this.list = data.sort((a, b) => {
            return new Date(a.time) - new Date(b.time);
          });
          this.e1 = 1;
          this.event = JSON.parse(JSON.stringify(this.default_event));
        })
        .catch(err => {
          this.isLoading = false;
        });
    },
    onSave() {
      this.dialog = false;
      this.isLoading = true;
      let split = String(this.picker).split("-");
      let year = split[0];
      let month = split[1];
      let day = split[2];
      let nd = new Date(this.picker);
      nd.setUTCFullYear(Number(year));
      nd.setUTCMonth(Number(month) - 1);
      nd.setUTCDate(Number(day) + 1);

      nd.setMinutes(this.event.minute);
      nd.setHours(this.event.hour);
      if (this.event._id == null) {
        eventService
          .addEvent(this.id, this.event.name, nd, this.event.message)
          .then(data => {
            this.isLoading = false;
            this.initialize();
          })
          .catch(err => {
            this.isLoading = false;
            console.log(err);
            this.initialize();
          });
      } else {
        eventService
          .editEvent(
            this.id,
            this.event._id,
            this.event.name,
            nd,
            this.event.message
          )
          .then(data => {
            this.isLoading = false;
            this.initialize();
          })
          .catch(err => {
            this.isLoading = false;
            console.log(err);
            this.initialize();
          });
      }
    },
    addEvent({ date }) {
      if (date != undefined && new Date(date).valueOf() != Number.NaN) {
        this.picker = new Date(date).toISOString().substr(0, 10);
              // this.event = JSON.parse(JSON.stringify(this.default_event));
      } else {
        this.picker = new Date().toISOString().substr(0, 10);
      }
      if(this.event._id){
        this.event = JSON.parse(JSON.stringify(this.default_event));
      }
      this.dialog = !this.dialog;
    },
    editEvent(object) {
      let filtered = this.list.filter(obj => {
        return String(obj._id) == String(object._id);
      });
      if (filtered.length == 0) {
        return;
      }
      let event = filtered.pop();
      this.event.hour = new Date(event.time).getHours();
      this.event.minute = new Date(event.time).getMinutes();
      this.event._id = event._id;
      this.event.name = event.name;
      this.event.message = event.message;
      this.picker = new Date(event.time).toISOString().substr(0, 10);
      this.dialog = !this.dialog;
    },
    onRemove({ _id, name }) {
      if (!confirm(`Are you sure you want to remove "${name}"`)) {
        return;
      }
      this.isLoading = true;
      eventService
        .removeEvent(_id)
        .then(data => {
          this.isLoading = false;
          this.initialize();
        })
        .catch(err => {
          console.log(err);
          this.isLoading = false;
        });
    }
  },
  watch: {
    time() {
      // console.log(this.time);
    },
    picker() {
      // console.log(this.picker)
    }
  },
  mounted() {
    this.initialize();
  }
};
</script>
